// extracted by mini-css-extract-plugin
export default {"tabDark":"pill-tabs_tabDark__PKaxc","tabSoft":"pill-tabs_tabSoft__CYt7N"};